export enum TripType {
  Walk,
  Bus,
  MP,
  NP,
  EP,
  Compline,
  PrayerList,
  Silence,
  Icon,
  Yoga,
  InviteToChurch,
  SundayWorship,
  ReadAChapter,
  CallAFriend,
  WriteALetter,
  MemorizeAVerse,
  ListenToAPodcast,
  ReadDevotional,
  IncreasePledge,
  BakeCookies,
  GiveSomethingAway,
  Charity
}